exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-success {\n  background: #09a699;\n  color: white;\n}\n.modal-header .close {\n  margin-top: -20px !important;\n}\n.traffic-red {\n  background-color: rgb(255 0 0 / 20%);\n}\n.traffic-yellow {\n  background-color: rgb(255 255 0 / 20%);\n}\n.traffic-green {\n  background-color: rgb(0 128 0 / 20%);\n}\n.add-comp-header .btn {\n  margin-right: 10px;\n}\n", ""]);

// exports
